// extracted by mini-css-extract-plugin
export var card = "FlavorlessCards-module--card--4d677";
export var cardImage = "FlavorlessCards-module--cardImage--92544";
export var container = "FlavorlessCards-module--container--04854";
export var image = "FlavorlessCards-module--image--d4bb3";